import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { FooterMenu } from '../footerMenu/FooterMenu.jsx';
import { Flag } from './Header.jsx';

/**
 * Pre-footer funnel band: every content page ends on the money path
 * (/concierge), not dead space. Pages that ARE the funnel (Concierge)
 * pass showCta={false}.
 */
function PreFooterCTA() {
  return (
    <section className="fi-prefoot" aria-label="Get help buying">
      <div className="fi-wrap">
        <h2>Done nodding along? Go get one.</h2>
        <p>
          We match you to the right EV, hand you the Survival Kit playbook, and read the dealer's
          quote before you sign it. Free, and we don't sell your email to anyone.
        </p>
        <RouterLink
          className="fi-btn fi-btn--ink"
          to="/concierge"
          onClick={() => { if (window.gtag) window.gtag('event', 'prefooter_cta_concierge', {}); }}
        >
          Get help buying an EV, free
        </RouterLink>
      </div>
    </section>
  );
}

export const PageFooter = ({ showCta = true }) => {
  return (
    <>
      {showCta && <PreFooterCTA />}
      <footer className="fi-foot">
        <div className="fi-wrap">
          <div className="fi-foot-g">
            <div>
              <Flag />
              <p className="fi-foot-blurb">Most of us are still idiots about EVs. This is the cure. Sourced, free, and slightly rude.</p>
            </div>
            <FooterMenu />
          </div>
          <div className="fi-legal">
            <span>&copy; 2026 <a href="https://adamapps.co">ADAMAPPS, LLC</a></span>
            <span>Fact-checked. Not financial advice. Still free.</span>
          </div>
        </div>
      </footer>
    </>
  );
};
